var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelgium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4408",
    height: 600,
    width: 900,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3148",
    d: "m-479.99183 20.215956a156.8 156.8 0 0 1 157.9935-155.193176 156.8 156.8 0 0 1 155.59627 157.596526 156.8 156.8 0 0 1 -157.19852 155.998364 156.8 156.8 0 0 1 -156.39944-156.799497",
    transform: "matrix(1.499 0 0 1.499 740.133 -223.272)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3358",
    transform: "scale(-1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3220",
    d: "m-900-536h300v600h-300z",
    fill: "#e32d3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect3990",
    d: "m-600-536h300v600h-300z",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect3992",
    d: "m-300-536h300v600h-300z",
    fill: "#222"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelgium);
export default __webpack_public_path__ + "static/media/BELGIUM.d51a662ff40f5d18b0ab24b5c2f394c8.svg";
export { ForwardRef as ReactComponent };